import React from "react";
import AppShell from "./AppShell";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import AnalyticsTracker from "./components/AnalyticsTracker";

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppShell />
        <AnalyticsTracker /> {/* 路由变化时上报 GA */}
      </BrowserRouter>
    </HelmetProvider>
  );
}
